import React, { FC, useState } from 'react';
import { Button, Spin } from 'antd';
import { useAppDispatch, useAppSelector } from 'common/hooks';
import { TextEditor } from 'entities/Notes/components';

interface IComponentProps {
  eventId?: number;
}

export const Notes: FC<IComponentProps> = ({ eventId }) => {
  const { noteLoading } = useAppSelector((state) => ({ noteLoading: state.note.loading }));
  const { note: noteDispatch } = useAppDispatch();
  const [value, setValue] = useState<string>('');

  const onSaveClick = () => {
    if (eventId) {
      noteDispatch.createNote({
        eventId,
        note: value,
        onSuccess: () => setValue(''),
      });
    }
  };

  return (
    <div className="notes">
      <Spin wrapperClassName="notes__spin" spinning={noteLoading}>
        <div className="ff-medium fs-lg">Notes</div>

        <TextEditor value={value} onChange={setValue} />

        <div className="d-flex align-center" style={{ gap: 16 }}>
          <Button className="blue" onClick={onSaveClick}>
            Save
          </Button>

          <Button className="red" onClick={() => setValue('')}>
            Discard
          </Button>
        </div>
      </Spin>
    </div>
  );
};
